import React, { useState, forwardRef, useImperativeHandle } from "react";
import {Button,
        Dialog,
        DialogActions,
        DialogContent,
        DialogContentText,
        DialogTitle,
        CircularProgress
} from "@material-ui/core";

import { sendNotification } from "../../context/UserContext";
import useStyles from './styles';
import ttAPI from '../../api/ttAPI';

const RefundConfirmation = forwardRef((props, ref) => {
    const { closeMenu, onConfirmationSuccess } = props;
    const classes = useStyles();
    const [refundId, setRefundId] = useState(-1);
    const [refundIds, setRefundIds] = useState('');
    const [actionName, setActionName] = useState(''); // 'APPROVE', 'DELETE'
    const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
    const [isConfirming, setIsConfirming] = useState(false);

    useImperativeHandle(ref, () => ({

      openDeleteAllConfirmationPopup(refundIds) {
        setRefundIds(refundIds);
        setRefundId(-1);
        setActionName('DELETE');
        handleClickConfirmationPopup();
      },

      openApproveAllConfirmationPopup(refundIds) {
        setRefundIds(refundIds);
        setRefundId(-1);
        setActionName('APPROVE');
        handleClickConfirmationPopup();
      },

      openDeleteConfirmationPopup(refundId) {
        setRefundId(refundId);
        setRefundIds('');
        setActionName('DELETE');
        handleClickConfirmationPopup();
      },

      openApproveConfirmationPopup(refundId) {
        setRefundId(refundId);
        setRefundIds('');
        setActionName('APPROVE');
        handleClickConfirmationPopup();
      }

    }));


    const handleClickConfirmationPopup = () => {
      //closeMenu(); // handle closing menu after confirmation success, so don't do it here
      setOpenConfirmDialog(true);
    };

    const handleCloseConfirmation = () => {
      setOpenConfirmDialog(false);
      closeMenu();
    };

    const handleConfirm = async() => {
      setIsConfirming(true);
      var response = null;
      if (actionName === 'APPROVE') {
          if (refundId >= 0 ) {
              response = await ttAPI.approveRefund(refundId);
          }
          else {
              response = await ttAPI.approveRefunds(refundIds);
          }
      } else if (actionName === 'DELETE') {
          if (refundId >= 0 ) {
              response = await ttAPI.deleteRefund(refundId);
          }
          else {
              response = await ttAPI.deleteRefunds(refundIds);
          }
      }
      setIsConfirming(false);

      if (response) {
          sendNotification('success', `Success - Refund${refundId >= 0  ? '' : 's'} ${actionName}D.`, classes);
          handleCloseConfirmation();
          onConfirmationSuccess();
      }
      else {
          sendNotification('error', `Error - Refund${refundId >= 0  ? '' : 's'} ${actionName}D.`, classes);
      }
    };


  return (
    <>
    <Dialog open={openConfirmDialog} onClose={handleCloseConfirmation} disableBackdropClick={true}

        PaperProps={{
          style: {
            boxShadow: 'none',
          },
        }}
    >
      <DialogTitle id="form-dialog-title">{actionName} Refund{refundId >= 0  ? '' : 's'}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Are you sure you want to {actionName} {refundId >= 0 ? `Refund ${refundId}` : 'ALL Refunds on the list'}?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCloseConfirmation} className={classes.cancelButton}>
          Cancel
        </Button>
          <Button onClick={handleConfirm} disabled={isConfirming}>
            {isConfirming && <span><CircularProgress size={25}/> Confirming...</span>}
            {!isConfirming && <span>Confirm</span>}
          </Button>
      </DialogActions>
    </Dialog>
    </>
  );
});
export default RefundConfirmation;
